import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { ApiClient } from '../api-client';
import { Password } from './password';

@Injectable()
export class PasswordService extends ApiClient {
  path: string;

  constructor(protected http: Http) {
    super(http);
  }

  getToken(email: string, password: string): Observable<any> {
    this.path = `${this.baseUrl}/token`;
    const body = JSON.stringify({email, password});

    return this.post(this.path, body);
  }

  recoverPassword(email: string): Observable<any> {
    this.path = `${this.baseUrl}/password_tokens`;
    const body = JSON.stringify({email});

    return this.post(this.path, body);
  }

  resetPassword(password: string, token: string): Observable<any> {
    this.path = `${this.baseUrl}/passwords/new`;
    const body = JSON.stringify({password, token});

    return this.post(this.path, body);
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    this.path = `${this.baseUrl}/passwords/reset`;
    const body = JSON.stringify({old_password: oldPassword, new_password: newPassword});

    return this.post(this.path, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/password.service.ts